import CommonDesign from './CommonDesign.view';

export default CommonDesign;
